import { axios } from 'boot/axios'

export default {
  namespaced: true,
  state: {
    items: []
  },

  getters: {
    findIndex: ({ items }) => itemId => items.findIndex(({ id }) => id === itemId),
    find: ({ items }) => itemId => items.find(({ id }) => id === itemId),

    getProvenience: (state, { find, findIndex }) => provenienceId => findIndex(provenienceId) === -1 ? {} : find(provenienceId),
    getProvenienceLabel: (state, { getProvenience }) => provenienceId => getProvenience(provenienceId).name,

    provenienceOptions: ({ items }) => items.map(({ id, name }) => ({ label: name, value: id }))
  },

  actions: {
    fetchProveniences ({ commit, state: { items } }) {
      if (items.length === 0) {
        axios.get('proveniences').then(({ data }) => { commit('SET_PROVENIENCES', data) })
      }
    }
  },

  mutations: {
    SET_PROVENIENCES (state, data) { state.items = data }
  }
}
